import styled from "styled-components";
import { ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";

export const WeekHeader = styled.div`
  padding: 16px 24px;
  border-radius: 24px;
  background: ${ColorV2.White};
  width: 100%;
  max-width: 100%;
  margin-top: 16px;
`;

export const WeekView = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 24px;
`;

export const DayCard = styled.div<{ $isToday: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 8px 12px;
  border-radius: 16px;
  flex: 1 1 0;
  min-width: 0;
  background: ${(props) => (props.$isToday ? ColorV2.Blue7 : "transparent")};
  cursor: pointer;
  transition:
    background-color 160ms ease,
    box-shadow 160ms ease,
    transform 160ms ease;

  &:hover {
    background: ${ColorV2.Blue7};
    box-shadow: 0 2px 8px ${ColorV2.Blue6};
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
    box-shadow: none;
  }

  &:focus-visible {
    outline: 2px solid ${ColorV2.Blue2};
    outline-offset: 2px;
  }
`;

export const DayName = styled.div`
  ${TypographyV2.b1};
  color: ${ColorV2.Blue1};
`;

export const DayDate = styled.div<{ $isToday: boolean }>`
  ${TypographyV2.s1};
  color: ${(props) => (props.$isToday ? ColorV2.Blue1 : ColorV2.Blue4)};
`;
